import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/api';
import DeletePositionWidget from './DeletePositionWidget';
import MovePositionWidget from './MovePositionWidget';
import UsersModal from '../Users/UsersModal';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [showUsersModal, setShowUsersModal] = useState(false);
  const navigate = useNavigate();
  const userGuideUrl = `${process.env.PUBLIC_URL || ''}/Tikwiz_User_Guide.pdf`;

  useEffect(() => {
    const loadCurrentUser = async () => {
      const token = authService.getToken();
      if (token) {
        try {
          const user = await authService.getCurrentUser(token);
          setCurrentUser(user);
        } catch (error) {
          console.error('Failed to load current user:', error);
          handleLogout();
        }
      } else {
        navigate('/');
      }
    };

    loadCurrentUser();
  }, [navigate]);

  const handleLogout = () => {
    authService.logout();
    navigate('/');
  };

  if (!currentUser) {
    return (
      <div className="dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>TikwizDB Admin Dashboard</h1>
          <div className="user-info">
            <span>Welcome, {currentUser.email}</span>
            <a
              className="user-guide-link"
              href={userGuideUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open user guide"
              title="Open user guide"
            >
              i
            </a>
            <button className="btn btn-secondary" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="dashboard-main">
        <MovePositionWidget className="dashboard-shared-move-widget" />
        <DeletePositionWidget className="dashboard-shared-move-widget" />

        <div className="dashboard-grid">
          <div className="management-card">
            <div className="card-icon">USR</div>
            <h2>Users Management</h2>
            <p>Manage user accounts, roles, and permissions</p>
            <button
              className="btn btn-primary"
              onClick={() => setShowUsersModal(true)}
            >
              Manage Users
            </button>
          </div>

          <div className="management-card">
            <div className="card-icon">TBL</div>
            <h2>Tables Management</h2>
            <p>View and manage database tables and structures</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/dashboard/tables')}
            >
              Manage Tables
            </button>
          </div>

          <div className="management-card">
            <div className="card-icon">INV</div>
            <h2>Inventory Snapshot</h2>
            <p>View Inv/Tickets/Shows for all users and rebuild snapshot.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/dashboard/inventory')}
            >
              Open Inventory
            </button>
          </div>

          <div className="management-card">
            <div className="card-icon">EVT</div>
            <h2>Events Display</h2>
            <p>Browse New_York / North_America events with linked users.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/dashboard/events')}
            >
              Events
            </button>
          </div>

          <div className="management-card">
            <div className="card-icon">PNL</div>
            <h2>Financials</h2>
            <p>Review monthly PnL, revenue, investment, and ROI by tab.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate('/dashboard/financials')}
            >
              Financials
            </button>
          </div>
        </div>

        <div className="dashboard-stats">
          <div className="stat-card">
            <h3>System Status</h3>
            <p className="status-indicator online">Online</p>
          </div>
        </div>
      </main>

      {showUsersModal && (
        <UsersModal
          isOpen={showUsersModal}
          onClose={() => setShowUsersModal(false)}
          currentUser={currentUser}
        />
      )}
    </div>
  );
};

export default AdminDashboard;
